<template>
    <div class="flex header">
         <div class="logo flex">
                <img src="@/assets/images/logo.png" alt="">
                <i class="el-icon-s-fold"></i>
            </div>
            <div class="header_part flex"> 
                <div class="item">
                    <ul class="flex header_link">
                        <li><router-link tag="a" :to="{ name: 'Home' }"><span>首页</span></router-link></li>
                        <li><router-link tag="a" :to="{ name: 'Home' }"><span>收藏专区</span></router-link></li>
                    </ul>
                </div>
                <div class="item"><UserMenu v-bind:size="45" class="menu"></UserMenu></div>
            </div>
    </div>
</template>

<script>
import UserMenu from '@/components/tools/UserMenu'
export default {
    name:'GlobalHeader',
    components:{
	    UserMenu
    },
}
</script>

<style scoped>
.header{box-shadow: 0 2px 12px 0 rgba(123, 123, 123, 0.2);padding: 0 20px;width: 100%;z-index: 99;}
.logo{align-items: center;justify-content: space-between;width: 280px;height: 100%;}
.logo img{height: 28px;}
.logo i{font-size: 30px;}
.header_part{height: 100%;align-items: center;justify-content: space-between;width: 100%;padding-left: 65px;}
.header_link{align-items: center;}
.header_link li{padding:0 15px;}
.header_link span{color: #676c7b;font-size: 16px;}
.header_link span:hover{color: #0051a4;}
.menu >>> .user-name{font-size: 16px;color: #676c7b !important;font-weight: bold;}
</style>